import { createBrowserHistory } from "history";

const history = createBrowserHistory({ window });

export default history;
